export default __webpack_public_path__ + "static/rogers-49935e03245ca7d37d0aed5a3b700086.jpg";